import type { MeddraTerm } from '@/lib/api/generated/casedb';
import { CODING_ACTION, type CodingState } from '@/features/meddra/shared/model/meddraCoding';

/** Display bindings only: the server still validates and projects the saved coding command. */
const EVENT_FIELDS = ['coded_term', 'preferred_term', 'preferred_term_code', 'lower_level_term', 'lower_level_term_code', 'soc', 'soc_code', 'high_level_term', 'high_level_term_code', 'high_level_group_term', 'high_level_group_term_code'];
const HISTORY_FIELDS = ['disease_coded_term', 'event_code', 'coding_dictionary'];
const INDICATION_FIELDS = ['pt', 'llt'];
export const CODING_DRAFT_NOTE = 'Unsaved coding preview. Use MedDRA coding to change these values.';

export function codingPreviewFields(fieldId: string): string[] {
  if (fieldId.includes('.medical_history.')) return HISTORY_FIELDS;
  if (fieldId.includes('.indications.')) return INDICATION_FIELDS;
  return EVENT_FIELDS;
}

export function codingDraftValues(fieldId: string, state: CodingState, term?: MeddraTerm): Record<string, string | null> | undefined {
  if (!state.action || state.action === CODING_ACTION.confirm) return undefined;
  const empty: Record<string, string | null> = Object.fromEntries(codingPreviewFields(fieldId).map(key => [key, null]));
  if (state.action === CODING_ACTION.clear) return empty;
  if (state.action === CODING_ACTION.manual) {
    return Object.fromEntries(Object.keys(empty).map(key => [key, state.raw?.[key] ?? null]));
  }
  if (state.action !== CODING_ACTION.select) return undefined;
  const path = term?.paths?.find(item => item.pathId === state.pathId);
  if (!term || !path) return empty;
  if (fieldId.includes('.medical_history.')) return { disease_coded_term: term.name ?? null, event_code: term.code ?? null, coding_dictionary: 'MedDRA' };
  if (fieldId.includes('.indications.')) return { pt: term.pt ?? null, llt: term.name ?? null };
  return {
    coded_term: term.name ?? null, lower_level_term: term.name ?? null, lower_level_term_code: term.code ?? null,
    preferred_term: term.pt ?? null, preferred_term_code: term.ptCode ?? null,
    soc: path.soc ?? null, soc_code: path.socCode ?? null,
    high_level_term: path.hlt ?? null, high_level_term_code: path.hltCode ?? null,
    high_level_group_term: path.hlgt ?? null, high_level_group_term_code: path.hlgtCode ?? null,
  };
}
